export enum LocalStorageEnum {
  GuestKey = '@liv-famly-pfo:guest-key',
  AccessToken = '@liv-famly-pfo:access-token',
  User = '@liv-famly-pfo:user',
  NpsSurvey = '@liv-famly-pfo:nps-survey'
}
